import React from 'react';
import styled from 'styled-components';
import { BoldSmallBodyText, Icon, IconType, SmallBodyText } from 'ui-toolkit';

export interface ProgressStepTextProps {
  heading: string;
  isCurrent?: boolean | null;
  isHidden?: boolean | null;
  subheading: string;
  subtext?: string | null;
}

export const StyledProgressStepText = styled.div`
  text-align: center;
`;

export const StyledSubheader = styled(SmallBodyText)`
  align-items: center;
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing2};
  grid-auto-flow: column;
  justify-content: center;
`;

export const StyledSubtext = StyledSubheader;

export const StyledIcon = styled(Icon)`
  height: 24px;
  width: 24px;
`;

const AnchorDiv = styled.div`
  position: relative;
`;

const PositionedDiv = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: 200px;
`;

const ProgressStepText: React.FC<ProgressStepTextProps> = ({ heading, isCurrent, isHidden, subheading, subtext }) => (
  <StyledProgressStepText>
    {!isHidden ? (
      <AnchorDiv>
        <PositionedDiv>
          <BoldSmallBodyText>{heading}</BoldSmallBodyText>
          <StyledSubheader>
            {subheading ? subheading : <>&nbsp;</>}
            {isCurrent && !subtext ? <StyledIcon type={IconType.Publish} /> : null}
          </StyledSubheader>
          {isCurrent && !!subtext ? (
            <StyledSubtext>
              {subtext}
              &nbsp;
              <StyledIcon type={IconType.Publish} />
            </StyledSubtext>
          ) : null}
        </PositionedDiv>
      </AnchorDiv>
    ) : null}
  </StyledProgressStepText>
);

export default ProgressStepText;
